import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.concat.js";
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? null : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreateWithParentId0]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("component-form", {
      "ref": "form",
      "on": {
        "success": this.onFormSuccess
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'MENU_ALL',
        delete: 'MENU_DELETE'
      },
      permission: {
        query: 'system:menu:query',
        add: 'system:menu:add',
        edit: 'system:menu:edit',
        remove: 'system:menu:remove'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'menu_name',
        label: '名称',
        minWidth: '200px',
        fixed: 'left'
      }, {
        prop: 'icon',
        label: '图标',
        render: function render(_ref) {
          var row = _ref.row;
          return row.icon ? h("d2-icon", {
            "attrs": {
              "name": row.icon
            }
          }) : h("span", {
            "class": "d2-opacity-3"
          }, ["\u65E0"]);
        },
        width: '60px'
      }, {
        prop: 'url',
        label: '菜单链接',
        minWidth: '200px'
      }, {
        prop: 'perms',
        label: '权限标识',
        width: '200px'
      }, {
        prop: 'route_name',
        label: '路由名称',
        minWidth: '160px'
      }, {
        prop: 'route_path',
        label: '路由地址',
        minWidth: '160px'
      }, {
        prop: 'route_component',
        label: '路由组件',
        minWidth: '160px'
      }, {
        prop: 'route_cache',
        label: '路由缓存',
        render: function render(_ref2) {
          var row = _ref2.row;
          return h("d2-dict", {
            "attrs": {
              "name": "is",
              "value": row.route_cache
            }
          });
        },
        width: '80px'
      }, {
        prop: 'id',
        label: 'ID',
        width: '100px',
        show: false
      }, {
        prop: 'order_num',
        label: '显示排序',
        minWidth: '100px'
      }, {
        prop: 'menu_type',
        label: '类型',
        render: function render(_ref3) {
          var row = _ref3.row;
          return h("d2-dict", {
            "attrs": {
              "name": "menu_type",
              "value": row.menu_type
            }
          });
        },
        width: '60px'
      }, {
        prop: 'is_frame',
        label: '外链',
        render: function render(_ref4) {
          var row = _ref4.row;
          return h("d2-dict", {
            "attrs": {
              "name": "is",
              "value": row.is_frame
            }
          });
        },
        width: '60px'
      }, {
        prop: 'visible',
        label: '可见性',
        render: function render(_ref5) {
          var row = _ref5.row;
          return h("d2-dict", {
            "attrs": {
              "name": "visible",
              "value": row.visible
            }
          });
        },
        width: '60px'
      }, {
        prop: 'create_by',
        label: '创建人员',
        width: '100px',
        show: false
      }, {
        prop: 'created_at',
        label: '创建时间',
        formatter: function formatter(row) {
          return utils.time.format1(row.created_at, 'YYYY/M/D HH:mm:ss');
        },
        width: '140px',
        show: false
      }, {
        prop: 'update_by',
        label: '更新人员',
        width: '100px',
        show: false
      }, {
        prop: 'updated_at',
        label: '更新时间',
        formatter: function formatter(row) {
          return utils.time.format1(row.updated_at, 'YYYY/M/D HH:mm:ss');
        },
        width: '140px',
        show: false
      }, {
        prop: 'remark',
        label: '备注',
        width: '200px',
        show: false
      } // { prop: 'operatings', label: 'operatings', width: '200px', show: true,
      //     render: ({ row }) => ( <el-button icon="el-icon-edit-outline" type="success">成功按钮</el-button> }),
      ];
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref6) {
        var row = _ref6.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('add', [{
          icon: 'el-icon-plus',
          type: 'primary',
          action: function action() {
            return _this2.create({
              parent_id: row.id
            });
          }
        }], [])), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: "\u786E\u5B9A\u5220\u9664 [ ".concat(row.menu_name, " ] \u5417"),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'menu_name',
        label: '名称',
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.menu_name,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "menu_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'visible',
        label: '可见性',
        default: this.$env.VUE_APP_DICT_EMPTY_NUMBER,
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "visible",
              "button": true,
              "all": true
            },
            "model": {
              value: _this3.search.form.model.visible,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "visible", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: {
    onFormSuccess: function onFormSuccess() {
      this.$store.dispatch('d2admin/permission/load', {
        focus: true
      });
      this.research();
    }
  }
};